import { Image, Text, Tooltip } from '@chakra-ui/react';
import * as T from '../../../../../../components/Table';
import { useState } from 'react';

export function SummaryItem({ item }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <T.Tr>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        <Tooltip
          hasArrow
          bg="white"
          isOpen={isOpen}
          label={
            <>
              <Image
                src={item.link_imagem}
                width="150px"
                height="150px"
                objectFit="contain"
                fallbackSrc="https://via.placeholder.com/150"
              />
              <br />
              <Text fontSize="12px" color="black" fontWeight="semibold" textAlign="center">
                {item.nome_produto}
              </Text>
            </>
          }>
          <Text
            cursor="pointer"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}>
            {item.codigo_produto}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.quantidade_negociada}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.preco_base}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.subtotal_preco}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.valor_unitario}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.subtotal_vlrunit}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.diferenca}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.dif_menosimp}
      </T.Td>
    </T.Tr>
  );
}
